// extracted by mini-css-extract-plugin
module.exports = {"modalClass":"styles_modalClass__P9p20","button":"styles_button__3DSdU","cancel":"styles_cancel__3EAlr","delete":"styles_delete__3KYIe"};